import { FunnelStep } from '@/api/analyticsService';
import { formatNumber } from '@/lib/format';
import { useChartTheme } from './chartTheme';

interface ActivationFunnelProps {
  steps: FunnelStep[];
}

const ActivationFunnel = ({ steps }: ActivationFunnelProps) => {
  const t = useChartTheme();

  return (
    <ul className="flex flex-col gap-4">
      {steps.map((step, i) => {
        const prev = i > 0 ? steps[i - 1].count : step.count;
        const stepDrop = prev > 0 ? Math.round((step.count / prev) * 1000) / 10 : 0;
        return (
          <li key={step.event} className="flex flex-col gap-1">
            <div className="flex items-baseline justify-between gap-3">
              <span className="text-sm text-gray-700 dark:text-gray-200">{step.label}</span>
              <span className="shrink-0 text-sm font-semibold tabular-nums text-gray-900 dark:text-white">
                {formatNumber(step.count)}
                <span className="ml-2 text-xs font-normal text-gray-400 dark:text-gray-500">
                  {step.conversionRate}%
                </span>
              </span>
            </div>
            <div className="h-6 overflow-hidden rounded-lg bg-gray-100 dark:bg-gray-800">
              <div
                className="flex h-full items-center rounded-lg"
                style={{
                  width: `${Math.max(step.conversionRate, 2)}%`,
                  backgroundColor: t.series[0],
                }}
              />
            </div>
            {i > 0 && (
              <span className="text-xs text-gray-400 dark:text-gray-500">
                {stepDrop}% depuis l'étape précédente
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default ActivationFunnel;
